import { render, staticRenderFns } from "./GetDocumentStatus.vue?vue&type=template&id=5af4134e&"
import script from "./GetDocumentStatus.vue?vue&type=script&lang=js&"
export * from "./GetDocumentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports